import { DirectiveBinding } from "vue/types/options";
import { VNode } from "vue";

export default {
  bind: function(el: HTMLElement, binding: DirectiveBinding, vnode: VNode) {
    // console.log("element", el);
    // console.log("binding", binding);
    // console.log("vNode", vnode);
  }
};
